import { appSettingsApi } from '../api/appSettings'

let appSettingsCache: Record<string, string | number | boolean> | null = null

const parseCookieConsent = (): Record<string, boolean> => {
  try {
    const cookieConsent = localStorage.getItem('cookiefirst-consent')
    return JSON.parse(cookieConsent || '{}')
  } catch {
    return {}
  }
}

export const hasFunctionalConsent = (): boolean => {
  const consent = parseCookieConsent()
  return consent.functional === true
}

export const isFreshchatEnabled = async (): Promise<boolean> => {
  try {
    if (!appSettingsCache) {
      appSettingsCache = await appSettingsApi.getAppSettings()
    }
    const value = appSettingsCache.freshchatEnabled
    return value === true || value === 'true'
  } catch {
    return false
  }
}

export const shouldLoadFreshchat = async (): Promise<boolean> => {
  if (!(await isFreshchatEnabled())) {
    return false
  }

  const env = process.env.REACT_APP_ENV
  if (env === 'development' || env === 'uat') {
    return true
  }

  return hasFunctionalConsent()
}

export const clearFreshchatAppSettingsCache = (): void => {
  appSettingsCache = null
}
